// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Preloader.assets/preloader.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Preloader.module.scss  */
.Preloader-module-Root_KaK {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover; }

.Preloader-module-centerPosition_2Cy {
  position: absolute;
  top: 50%;
  left: 50%; }

.Preloader-module-sSize_17a {
  width: 36px;
  height: 36px; }

.Preloader-module-mSize_ATx {
  width: 42px;
  height: 42px; }

.Preloader-module-lSize_3UG {
  width: 58px;
  height: 58px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Preloader/Preloader.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yDAAyD;EACzD,sBAAsB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS,EAAE;;AAEb;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,YAAY,EAAE","sourcesContent":["/*  imported from Preloader.module.scss  */\n.Preloader-module-Root_KaK {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  background-image: url(\"./Preloader.assets/preloader.gif\");\n  background-size: cover; }\n\n.Preloader-module-centerPosition_2Cy {\n  position: absolute;\n  top: 50%;\n  left: 50%; }\n\n.Preloader-module-sSize_17a {\n  width: 36px;\n  height: 36px; }\n\n.Preloader-module-mSize_ATx {\n  width: 42px;\n  height: 42px; }\n\n.Preloader-module-lSize_3UG {\n  width: 58px;\n  height: 58px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
